import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BecomeDealerModule } from './become-dealer.module';
import { enableProdMode } from '@angular/core';

enableProdMode();
const platform = platformBrowserDynamic();
platform.bootstrapModule(BecomeDealerModule);


// WEBPACK FOOTER //
// ./src/app/become-dealer/main.ts